module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_c/logo-aoj-ja-9ab02003e29d6eecd56f540ecb56ccd4.svg";